var render = function render(){var _vm=this,_c=_vm._self._c;return _c('dg-link',{staticClass:"back-button",attrs:{"href":{ name: 'PPMDashboard' }}},[_c('img',{attrs:{"src":require("../images/left-arrow.svg"),"alt":_vm.$t('ppm.back_btn')}}),_c('span',{staticClass:"back-button__text"},[_vm._v(_vm._s(_vm.$t("ppm.back_btn")))])])
}
var staticRenderFns = []

export { render, staticRenderFns }